import { Inject, Injectable } from '@angular/core';
import { APP_ENVIRONMENT } from '@shared/providers/environment.provider';
import { HttpClient } from '@angular/common/http';
import { Environment } from '../../types/environment';
import { Farm } from '../../types/farm';

@Injectable({
  providedIn: 'root',
})
export class FarmService {
  readonly API = `${this.env.apiUrl}/farm`;
  constructor(
    @Inject(APP_ENVIRONMENT) private readonly env: Environment,
    private readonly http: HttpClient,
  ) {}

  save(farm: Farm) {
    return this.http.post<Farm>(`${this.API}/save`, farm);
  }

  getById(id: number) {
    return this.http.get<Farm>(`${this.API}/getById?id=${id}`);
  }

  getAll(name?: string) {
    let url = `${this.API}/getAll`;
    if (name) {
      url += `?name=${name}`;
    }
    return this.http.get<Farm[]>(url);
  }

  toFarmMap(value: Farm[], key: keyof Farm): Map<string, Farm> {
    return value.reduce((previousValue, currentValue) => {
      return previousValue.set(currentValue[key]?.toString(), currentValue);
    }, new Map());
  }

  deleteById(id: number) {
    return this.http.post<void>(`${this.API}/deleteById?id=${id}`, null);
  }
}
